import View from "core/view";
import Element from "app/element";
import Deferred from "core/deferred";
import PlayerIcon from "core/player-icon";
export default function SurveyView(element) {
  const view = View({
    element
  });
  const questionnaire = Element("#game-questionnaire");
  const overlay = Element("#game-question", questionnaire);
  const info = Element('#game-question-info', questionnaire);
  const figure = Element('#game-question-figure', info);
  const progress = Element('#game-question-progress', info);
  const progressText = Element('#game-question-progresstext', progress);
  const questionBubble = Element("#game-question-bubble", overlay);
  const questionText = Element("#game-question-text", overlay);
  const questionAnswers = Element("#game-question-answers", overlay);
  const help = GamepadHelp(questionnaire);
  let playerFigure = figure;
  let selectedAnswer = null;
  let currentDeferred = null;
  function showIntro(intro) {
    questionBubble.setVisible(false);
    questionText.setVisible(false);
    questionAnswers.setVisible(false);
    questionAnswers.innerHTML = "";
    progress.setVisible(false);
    overlay.setVisible(false);
    questionText.innerHTML = intro;
    questionText.setVisible(true);
    help.setVisible(true);
    help.show("survey");
    overlay.setVisible(true);
    questionBubble.classList.add("shrink");
    questionBubble.setVisible(true);
    currentDeferred = new Deferred();
    return currentDeferred.promise;
  }
  function showOutro(outro) {
    questionAnswers.setVisible(false);
    questionAnswers.innerHTML = "";
    help.show("game");
    progress.setVisible(false);
    questionText.innerHTML = outro;
    questionBubble.classList.remove("shrink");
    currentDeferred = new Deferred();
    return currentDeferred.promise;
  }
  function showFollowUp(followUp) {
    questionAnswers.setVisible(false);
    questionText.innerHTML = followUp;
    currentDeferred = new Deferred();
    return currentDeferred.promise;
  }
  function setProgress(current, count) {
    progressText.innerHTML = `${current + 1} / ${count}`;
  }
  function setPlayer(playerId) {
    const oldFigure = playerFigure;
    playerFigure = PlayerIcon(playerId, "player_stand");
    info.replaceChild(playerFigure, oldFigure);
  }
  function askQuestion(text, answers) {
    questionText.innerHTML = text;
    questionAnswers.innerHTML = "";
    answers.forEach(answer => questionAnswers.appendChild(makeAnswer(answer)));
    questionAnswers.setVisible(true);
    progress.setVisible(true);
    questionBubble.classList.remove("shrink");
    selectedAnswer = null;
    currentDeferred = new Deferred();
    return currentDeferred.promise;
  }
  function selectPrevAnswer() {
    if (questionAnswers.isEmpty()) return;
    selectedAnswer && selectedAnswer.setSelected(false);
    if (selectedAnswer && selectedAnswer.previousElementSibling) {
      selectedAnswer = Element(selectedAnswer.previousElementSibling);
    } else {
      selectedAnswer = Element(questionAnswers.firstElementChild);
    }
    selectedAnswer && selectedAnswer.setSelected(true);
  }
  function selectNextAnswer() {
    if (questionAnswers.isEmpty()) return;
    selectedAnswer && selectedAnswer.setSelected(false);
    console.log("next");
    if (selectedAnswer && selectedAnswer.nextElementSibling) {
      selectedAnswer = Element(selectedAnswer.nextElementSibling);
    } else {
      selectedAnswer = Element(questionAnswers.lastElementChild);
    }
    selectedAnswer && selectedAnswer.setSelected(true);
  }
  function cancel() {
    questionBubble.classList.add("shrink");
    currentDeferred.reject("cancel");
  }
  async function submit() {
    questionBubble.classList.add("shrink");
    //await Element(questionBubble).waitForTransitionEnd();
    const hasAnswers = !questionAnswers.isEmpty();
    if (hasAnswers && !selectedAnswer) return;
    currentDeferred.resolve(hasAnswers ? selectedAnswer.innerHTML : null);
  }
  return Object.assign(view, {
    showIntro,
    showOutro,
    showFollowUp,
    selectNextAnswer,
    selectPrevAnswer,
    askQuestion,
    cancel,
    submit,
    setPlayer,
    setProgress
  });
}
function makeAnswer(answer) {
  const element = document.createElement("li");
  element.classList.add("game-question-answer");
  element.innerHTML = answer;
  return element;
}
function GamepadHelp(parent) {
  const help = Element("#game-question-help", parent);
  const screens = {
    "survey": Element(".gamepad-survey", help),
    "game": Element(".gamepad-game", help)
  };
  let shown = null;
  function show(screen) {
    if (shown) shown.setVisible(false);
    shown = screens[screen];
    shown.setVisible(true);
  }
  return Object.assign(help, {
    show
  });
}